<template>
  <div
    id="filter-trainee-modal"
    class="modal fade filter-trainee-modal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-borderless">
        <div class="modal-header">
          <h4 class="modal-title"></h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.stop.prevent="hideModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('form.local') }}</label>
                <select
                  class="form-control p-0 pl-2"
                  v-model="traineeLang"
                  id="locale"
                >
                  <option value="">{{ $t('allLanguages') }}</option>
                  <option value="DE">DE</option>
                  <option value="DK">DK</option>
                  <option value="EN">EN</option>
                  <option value="ES">ES</option>
                  <option value="FR">FR</option>
                  <option value="IT">IT</option>
                  <option value="NL">NL</option>
                  <option value="SE">SE</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('form.function') }}</label>
                <treeselect
                  :maxHeight="200"
                  v-model="selectedFunction"
                  :multiple="false"
                  :options="optionsFunctions"
                  :placeholder="$t('form.function')"
                  :normalizer="normalizerByTitle"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('form.service') }}</label>
                <treeselect
                  :maxHeight="200"
                  v-model="service"
                  :multiple="false"
                  :options="services"
                  :placeholder="$t('form.service')"
                  :normalizer="normalizerByTitle"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('establishment') }} </label>
                <treeselect
                  :maxHeight="200"
                  v-model="establishment"
                  :multiple="false"
                  :options="optionsEstablishments"
                  :placeholder="$t('establishment')"
                  :normalizer="normalizer"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex flex-wrap">
          <button
            @click.prevent.stop="filter"
            class="btn btn-primary d-flex align-items-center"
            :disabled="isLoading"
          >
            <div
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              v-if="isLoading"
            >
              <span class="sr-only"></span>
            </div>
            {{ $t('filter') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { lazyInput } from 'vue-lazy-input'
import { mapFields } from 'vuex-map-fields'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'FilterModal',
  directives: {
    lazyInput,
  },
  components: { DatePicker, Treeselect },
  data() {
    return {
      normalizerByTitle(node) {
        return {
          id: node.id,
          label: node.title,
        }
      },
      normalizer(node) {
        return {
          id: node,
          label: node,
        }
      },
      establishment: null,
      isLoaded: false,
      traineeLang: '',
      locale: '',
      showAlert: false,
      isSaving: false,
      service: null,
      selectedFunction: null,
      invalid: false,
      options: [],
      isLoading: false,
      optionsEstablishments: [],
      optionsFunctions: [],
      services: [],
      alert: {
        on: false,
        type: '',
        text: '',
      },
    }
  },
  computed: {
    ...mapFields(['user']),
    filterDataItems() {
      let arr = []

      if (this.traineeLang) {
        arr.push(this.traineeLang)
      }
      if (this.service) {
        arr.push(this.service)
      }
      if (this.establishment) {
        arr.push(this.establishment)
      }
      if (this.selectedFunction) {
        arr.push(this.selectedFunction)
      }
      return arr
    },
  },

  mounted() {
    this.isLoaded = true
    this.locale = document.head.querySelector('meta[name="app-locale"]').content
    this.$bus.$on('reset-filter-my-team', () => {
      this.traineeLang = null
      this.service = null
      this.establishment = null
      this.selectedFunction = null
      let data = {
        selectedFunction: null,
        service: null,
        traineeLang: null,
        establishment: null,
        page: 1,
        limit: 15,
      }
      this.$bus.$emit('filter-trainees', {
        data,
        filterDataItems: this.filterDataItems,
      })
    })
    this.$store.dispatch('trainees/getServices').then((resp) => {
      this.services = this.$lodash.sortBy(resp, 'title')
    })
    this.$store.dispatch('trainees/getEstablishments').then((resp) => {
      this.optionsEstablishments = resp.sort()
    })
    this.$store.dispatch('trainees/getFunctions').then((resp) => {
      this.optionsFunctions = this.$lodash.sortBy(resp, 'title')
    })
    this.$bus.$on('filter-trainee-modal.show', () => {
      this.isLoading = false
      $('#filter-trainee-modal').modal('show')
    })
    this.$bus.$on('hide-filter-trainee-modal', () => {
      this.hideModal()
    })
  },
  methods: {
    hideModal() {
      this.isLoading = false
      $('#filter-trainee-modal').modal('hide')
    },
    filter() {
      let data = {
        language: this.traineeLang,
        service: this.service,
        establishment: this.establishment,
        function: this.selectedFunction,
      }
      this.$bus.$emit('filter-trainees', {
        data,
        filterDataItems: this.filterDataItems,
      })
      this.isLoading = true
    },
  },
}
</script>

<style></style>
